<template>
  <v-sheet
      class="ma-auto rounded item"
      style="max-width: 1500px"
      :class="{
          'mb-5 pa-5': !$vuetify.display.mobile,
          'pa-0 mb-0 mt-0': $vuetify.display.mobile,
        }"
  >
    <div v-if="kickletUser">
      <v-data-table-server
          v-if="currency"
          v-model:items-per-page="itemsPerPage"
          v-model:page="page"
          :search="search"
          :headers="headers"
          :items-length="totalItems"
          :items="serverItems"
          :loading="loading"
          item-value="viewerKickUsername"
          @update:options="loadData"
          :items-per-page-options="itemsPerPageOptions"
          :hover="true"
      >
        <template v-slot:top>
          <h3 class="text-center mb-5">{{ $t('ranking.subTitle') }}</h3>
          <kicklet-text-field
              v-model="search"
              hide-details
              :label="$t('search-username')"
              density="compact"
              style="max-width: 300px"
          />
        </template>
        <template v-slot:item.rank="{ item }">
          <span class="color-primary">#{{ item.rank }}</span>
        </template>
        <template v-slot:item.watchTime="{ item }">
          {{ utils.formatWatchTime(item.watchTime) }}
        </template>
      </v-data-table-server>
    </div>
    <v-alert v-else :text="$t('ranking.no-streamer')" type="warning"></v-alert>
  </v-sheet>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { Stats } from '@/services/Stats';
import KickletTextField from '@/components/custom/kicklet/KickletTextField.vue';
import { Backend } from '@/services/Backend';

const headers = computed(() => {
  return [
    { title: 'Ranking', key: 'rank', sortable: false },
    { title: 'Username', key: 'viewerKickUsername', sortable: true },
    { title: 'Watchtime', key: 'watchTime', sortable: true },
    { title: 'Messages Sent', key: 'messagesSent', sortable: true },
    { title: currency, key: 'points', sortable: true },
  ];
});

const itemsPerPageOptions = [
  { value: 10, title: '10' },
  { value: 25, title: '25' },
  { value: 50, title: '50' },
  { value: 100, title: '100' },
];

const props = defineProps({
  kickletUser: Object,
});

const itemsPerPage = ref(10);
const page = ref(1);
const serverItems = ref([]);
const loading = ref(false);
const totalItems = ref(0);
const search = ref('');

const currency = ref(null);

onMounted(() => {
  Stats.getPublicCurrencyName(props.kickletUser.kickId)
    .then(resp => {
      const c = (resp.data.currency === 'points' ? 'Points' : resp.data.currency);
      currency.value = c;
    })
    .catch(Backend.handleError);
});

const loadData = async ({ page, itemsPerPage, sortBy }) => {
  loading.value = true;

  Stats.getPublicViewerRanking(props.kickletUser.kickId, page, itemsPerPage, sortBy[0]?.key, sortBy[0]?.order, search.value)
    .then(response => {
      serverItems.value = response.data.ranking;
      totalItems.value = response.data.count;
      loading.value = false;
    })
    .catch(error => {
      serverItems.value = null;
      console.log(error);
    });
};
</script>

<style scoped>
</style>
